






































import { Component, Vue, Ref, Prop, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { required } from '@/utils/validate';
import { trims } from '@/utils/helper';
import { ILoginParams } from '@/store/login/types';

const Login = namespace('login');

// 个人会员登录
@Component
export default class MemberLogin extends Vue {
  @Login.Action('login') public login!: (params: ILoginParams) => void;
  @Login.State('loading') public loading!: boolean;

  @Prop() public tab!: number;
  @Prop() public visible!: boolean;
  @Ref('form') public formRef!: HTMLFormElement;

  public required = required;
  public formData = { username: '', password: '', isRam: false, clientType: 'manage' };

  // 提交表单
  public onSubmit() {
    if (this.formRef.validate()) {
      this.login(trims(this.formData) as ILoginParams);
    }
  }

  @Watch('visible')
  public visibleChange(visible: boolean) {
     if (!visible) {
      this.formRef.reset();
     }
  }

  @Watch('tab')
  public tabChange() {
    this.formRef.reset();
  }
}
